// extracted by mini-css-extract-plugin
export default {"appBar":"AppBar_appBar__PABHC","leftContainer":"AppBar_leftContainer__YQT1d","logo":"AppBar_logo__2zMrq","avatar":"AppBar_avatar__gmrLO"};